import { actionTypes } from '@/core/constants'
import api from '@/core/apiclient'
import { DownloadFile } from '@/core/utils'

export default {
	async [actionTypes.ATA.DOCUMENTOS_ATA.BUSCAR_POR_FILTRO]({ state }, idAta) {
		const { filtro, paginacao, modalPenalidade } = state
		const { data } = await api.documentosAta.buscarListagem(filtro, paginacao, idAta, modalPenalidade)
		return data
	},
	async [actionTypes.ATA.DOCUMENTOS_ATA.EXCLUIR_DOCUMENTO_OU_ANEXO](context, documentoAnexo) {
		const documento = getDocumentoParaExcluir(documentoAnexo)
		return await api.documentosAta.excluir(documento)
	},
	async [actionTypes.ATA.DOCUMENTOS_ATA.BAIXAR_DOCUMENTO_ANEXO](context, documento) {
		const response = await api.documentosAta.baixar(documento)
		const headers = response.headers
		DownloadFile.downloadArrayBuffer(response.data, headers.filename, headers['content-type'], headers.extension)
	},
	async [actionTypes.ATA.DOCUMENTOS_ATA.ENVIAR_DOCUMENTO_PARA_PNCP](context, documento) {
		return await api.documentosAta.enviarPncp(documento.documentoId, documento.ataId)
	},
	async [actionTypes.ATA.DOCUMENTOS_ATA.EXCLUIR_DOCUMENTO_NO_PNCP](context, documento) {
		return await api.documentosAta.excluirPncp(documento.documentoId)
	},
	async [actionTypes.ATA.DOCUMENTOS_ATA.ENVIAR_DOCUMENTO_PARA_FORNECEDOR](context, obj) {
		await api.documentosAta.enviarFornecedor(obj)
	},
	async [actionTypes.ATA.DOCUMENTOS_ATA.SINCRONIZAR_AREA_PUBLICA](context, obj) {
		return await api.documentosAta.sincronizarAreaPublica(obj)
	},
	async [actionTypes.ATA.DOCUMENTOS_ATA.INSERIR](context, obj) {
		const { data } = await api.documentosAta.inserirDocumentoAta(obj)
		return data
	},
	async [actionTypes.ATA.DOCUMENTOS_ATA.SINCRONIZAR_AREA_PUBLICA_EM_LOTE](context, obj) {
		return await api.documentosAta.sincronizarAreaPublicaEmLote(obj)
	},
}

function getDocumentoParaExcluir(documentoAnexo) {
	return {
		idDocumentoAta: documentoAnexo.id,
		filtros: { tipoRegistroDocumento: documentoAnexo.tipoRegistroDocumento },
	}
}
